import jwt_decode from "jwt-decode";
import { parsedToken } from "@domains/utils/tokenParser";
class Authorizer {
    constructor(localStorage, cookieStorage) {
        this.getAuthToken = async () => {
            let token = "";
            const localStorageToken = await this.localStorage.get("jwt_token");
            if (localStorageToken) {
                token = localStorageToken;
            }
            else {
                token = await this.cookieStoarage.get("jwt_token");
            }
            if (token) {
                try {
                    const decoded_token = jwt_decode(token);
                    const authToken = decoded_token
                        ? parsedToken(decoded_token)
                        : "";
                    return authToken;
                }
                catch (e) {
                    return "";
                }
            }
            else {
                const authToken = "";
                return authToken;
            }
        };
        this._localStorage = localStorage;
        this._cookieStorage = cookieStorage;
    }
    get localStorage() {
        return this._localStorage;
    }
    get cookieStoarage() {
        return this._cookieStorage;
    }
}
export default Authorizer;
